import React, { useState , useEffect} from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Purnima.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import axios from 'axios';
import { Link } from 'react-router-dom';
import city from '../../../city.json'




const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};



const Purnima = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');


  const [purnimaList, setPurnimaList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPurnima, setSelectedPurnima] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const purnimaTooltips = {
  "January Purnima": "The first full moon of the year, January Purnima is considered auspicious for starting new spiritual practices and seeking blessings for a prosperous year ahead.",
  "February Purnima": "February Purnima is often associated with devotion and gratitude. Fasting and charity on this day are believed to purify the soul.",
  "March Purnima": "March Purnima is celebrated as Holi Purnima in many regions, marking the festival of colors and the victory of good over evil.",
  "April Purnima": "April Purnima is sacred for Hanuman Jayanti in many parts of India. Devotees worship Lord Hanuman and seek his strength and protection.",
  "May Purnima": "May Purnima is observed as Buddha Purnima, commemorating the birth, enlightenment, and death (Nirvana) of Lord Buddha.",
  "June Purnima": "June Purnima is a day to honor teachers and ancestors. Spiritual practices done on this day are believed to bring inner peace.",
  "July Purnima": "July Purnima is celebrated as Guru Purnima, a day dedicated to spiritual teachers. It is considered one of the most sacred days for gaining wisdom.",
  "August Purnima": "August Purnima is often linked with Raksha Bandhan in many years. It's a day for celebrating sibling bonds and offering prayers for protection.",
  "September Purnima": "September Purnima is observed with rituals for prosperity and peace. It is considered favorable for performing Satyanarayan puja.",
  "October Purnima": "October Purnima is marked by Sharad Purnima, when moonlight is believed to have healing properties. Kheer is traditionally kept under the moonlight and consumed for blessings.",
  "November Purnima": "November Purnima is celebrated as Kartik Purnima, a highly spiritual day associated with holy dips in rivers and lighting lamps for Lord Vishnu and Shiva.",
  "December Purnima": "December Purnima is ideal for introspection and cleansing. It encourages gratitude and preparing spiritually for the coming year."
};


useEffect(() => {
  const fetchPurnimaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/purnima?year=${year}&location=${encodeURIComponent(location)}`
      );
      
      
    

     
      if (response.data && response.data.purnimas) {
        setPurnimaList(response.data.purnimas);
      } else {
        setPurnimaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch Amavasya data:", error);
      setPurnimaList([]);
    }
  };

  fetchPurnimaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="Purnima-container">
      <InnerNav />
      <div className="Purnima-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Purnima Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                  
                  <p>{location}</p>
                </div>
               <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Pur-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
            
          </div>

{!selectedPurnima ? (
  <div className="purnima-list">
    {purnimaList.length === 0 && (
      <p>No purnima data available for selected year/location.</p>
    )}

    {purnimaList.map((item, idx) => (
      <div
        className="purnima-item clickable"
        key={idx}
        onClick={() => setSelectedPurnima(item)}
      >
        <img
          src="https://images.herzindagi.info/image/2023/Oct/sharad-purnima-23.jpg"
          alt={item.name}
        />

        <div className="purnima-details">
          <p className="purnima-date">{item.date}</p>
          <div className="purnima-name">{item.name}</div>
          <p className="purnima-phase">{item.phase}</p>
          <p className="purnima-tithi">{item.tithiName}</p>
        </div>

        <div className="purnima-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
        
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedPurnima(null)}
    >
      ← Back
    </button>

    <h2>{selectedPurnima.name}</h2>
        <img
      src="https://images.herzindagi.info/image/2023/Oct/sharad-purnima-23.jpg"
      alt={selectedPurnima.name}
    />
<p><strong>Date:</strong> {selectedPurnima.date}</p>
<p><strong>Phase:</strong> {selectedPurnima.phase}</p>
<p><strong>Tithi:</strong> {selectedPurnima.tithiName}</p>

<p>
  <strong>Tithi Start:</strong>{" "}
  {formatTime(selectedPurnima.tithiStart, timeFormat)}
</p>
<p>
  {purnimaTooltips[selectedPurnima.name] ||
    "This Purnima is spiritually significant and observed with fasting and prayers."}
</p>

<p>
  <strong>Tithi End:</strong>{" "}
  {formatTime(selectedPurnima.tithiEnd, timeFormat)}
</p>


    {/* <p>
      {purnimaTooltips[selectedPurnima.name] ||
        "No information available"}
    </p> */}

    {(() => {
      const parts = selectedPurnima.date.split(",");
      const month = parts[0]?.split(" ")[0];
      const day = parts[2]?.trim();

      return (
        <>
          <p><strong>Date:</strong> {selectedPurnima.date}</p>
          <p><strong>Day:</strong> {day}</p>
          <p><strong>Month:</strong> {month}</p>
        </>
      );
    })()}
  </div>
)}

        </div>

         <section className="purnima-wrapper">
      <h1 className="purnima-title">Purnima Days / Pournami Days</h1>
      <div className="purnima-texts">
        <p>
          This page lists actual Purnima or Pournami days on Hindu Lunar Calendar. This list might not be suitable for Shri Satyanarayana Puja which might be observed either on same day or one day before depending on starting time of Purnima Tithi on previous day.
        </p>

        <p>
          Pournami Vratam and 
          <Link to="/vrat/satyanarayana-puja" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Shri Satyanarayana Puja
          </Link>
          
          , which are observed on full moon day, might be observed one day before of Purnima Tithi. Please check Shri Satyanarayana Puja to know Shri Satyanarayana fasting days.
        </p>

        <p>
          Purnima fasting might be observed either on Purnima day or on one day before Purnima day i.e. on Chaturdashi day depending on starting time of Purnima Tithi on previous day.
        </p>

        <h2>Purnima Fasting or Pournami Vratham</h2>
        <p>
          Purnima fasting on Chaturdashi occurs only when Purnima starts during Madhyahna period on previous day. It is believed that if Chaturdashi prevails beyond Madhyahna then it pollutes Purnima Tithi and this Chaturdashi day should not be considered for Purnima fasting even if Purnima prevails during evening. There are no two opinions on this rule and DrikPanchang.com lists Purnima fasting days according to this rule.
        </p>

        <p>
          In North India full moon day is known as Purnima or Poornima. However in South India full moon day is known as Pournami or Pournima and fasting on this day is known as Pournami Vratam. Pournami Vratam is observed from sunrise to till sighting of the moon.
        </p>

        <p>
          Pournami Fasting days might not be same for two locations. Hence one should set the location before noting down Pournami Vratam dates.
        </p>
      </div>
    </section>
        {/* Ekadashi Calendar JSX ends here */}
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Purnima;
